import { BaseSensorWebController } from '../../base/controller/BaseSensorWebController';
import { BaseSensorWebComponent } from '../../base/BaseSensorWebComponent';
import { GCPSensorComponent } from '../component/GCPSensorComponent';
import { GCPSensorView } from '../view/GCPSensorView';
import { templateGCPSensor } from '../view/template';
import { IListenerConfig } from '../../../../framework/BaseWebComponentController';
import { GzInputFileWebComponent } from '../../../../ui/gzInputFile';
import { GzToastNotificationWebComponent } from '../../../../ui/gzToastNotification';
import { ToastSeverity } from '../../../../ui/gzToastNotification/type';
import { gcpUploadFileValidator } from '../validators/gcpUploadFileValidator';
import Joi from 'joi';
import { SensorEvent } from '../../types/sensor-type';

export class GCPSensorController extends BaseSensorWebController {
  public component: BaseSensorWebComponent;
  public view: GCPSensorView;
  public viewConstructor: typeof GCPSensorView;

  constructor(component: GCPSensorComponent) {
    super(component);
    this.initialSetup({
      viewConstructor: GCPSensorView,
      viewTemplate: templateGCPSensor,
    });
  }

  public isSensorEnabled(): boolean {
    return true;
  }

  computeEventListeners(): IListenerConfig[] {
    return super.computeEventListeners().concat([
      {
        element: this.view.dom.$subscriptionId,
        event: 'change',
        callback: this.inputChanged,
      },
      {
        element: this.view.dom.$importFileWrapper,
        event: 'change',
        callback: this.onFileInputChange,
      },
    ]);
  }

  public resetData(): void {
    super.resetData();
    this.view.dom.$subscriptionId.resetField();
  }

  public onFileLoad(e: ProgressEvent<FileReader>) {
    if (e.target && e.target.result && typeof e.target.result === 'string') {
      let result = {};
      try {
        result = JSON.parse(e.target.result);
        const { value, error }: Joi.ValidationResult = gcpUploadFileValidator.validate(result);
        //this.view.dom.$iss.value = e.target.result;
        if (error) {
          this.view.dom.$importFileWrapper.value = '';
          GzToastNotificationWebComponent.buildToastWrapperElement({
            message: this.dependencies.translateFn('Invalid JSON file') + error.message,
            severity: ToastSeverity.ERROR,
          });
        }
      } catch (e) {
        this.view.dom.$importFileWrapper.value = '';
        GzToastNotificationWebComponent.buildToastWrapperElement({
          message: this.dependencies.translateFn('Invalid JSON file'),
          severity: ToastSeverity.ERROR,
        });
      }
    }
    this.dispatchSensorEvent(SensorEvent.change, {
      type: this.component.getSensorType(),
      sourceEvent: e,
    });
  }

  private async onFileInputChange(): Promise<void> {
    const file = this.view.dom.$importFile.getFormValue();
    if (!file) {
      return;
    }

    const importGCPFile = file[0] as File;

    // validate filename
    if (!importGCPFile.name) {
      GzToastNotificationWebComponent.buildToastWrapperElement({
        message: this.dependencies.translateFn('Invalid filename'),
        severity: ToastSeverity.ERROR,
      });
      return;
    }

    // validate file type
    const allowedExtensions = /(\.json)$/i;
    if (!allowedExtensions.exec(importGCPFile.name)) {
      GzToastNotificationWebComponent.buildToastWrapperElement({
        message: this.dependencies.translateFn('Unsupported file type. Select a .json file and try again'),
        severity: ToastSeverity.ERROR,
      });
      return;
    }
    const reader = new FileReader();
    reader.onload = (e: ProgressEvent<FileReader>) => this.onFileLoad(e);

    reader.readAsText(importGCPFile);
  }
}
